module.exports = __webpack_public_path__ + "img/blog3.5cb759c3.jpg";